import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectsPage } from "~/pages/Projects/ProjectsPage";

export const Route = createFileRoute("/_app/projects/")({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.projects") }] }),
  component: ProjectsPage,
});
